// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluationPublicationCard-cls1_bx4","cls2":"EvaluationPublicationCard-cls2_K22 EvaluationPublicationCard-cls1_bx4"};